<template>
  <div>
    <v-snackbar
      v-model="infoAction.snackbar"
      :color="infoAction.color"
      top="top"
    >
      {{ infoAction.message }}

      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="infoAction.snackbar = false">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <center class="mt-3">
      <v-card
        color="#ffeeee"
        class="pa-1 rounded-pill"
        :width="$vuetify.breakpoint.xs ? '250px' : '410px'"
      >
        <div class="d-flex">
          <v-btn
            elevation="0"
            class="rounded-pill"
            :text="!isKonfirmasi"
            @click="(isKonfirmasi = true), goDataTiket()"
            style="color: #c90000"
            :width="$vuetify.breakpoint.xs ? '120px' : '200px'"
            small
            ><b>Konfirmasi</b></v-btn
          >
          <v-btn
            elevation="0"
            :text="isKonfirmasi"
            @click="(isKonfirmasi = false), goDataTiket()"
            class="rounded-pill"
            style="color: #c90000"
            :width="$vuetify.breakpoint.xs ? '120px' : '200px'"
            small
            ><b>Selesai</b></v-btn
          >
        </div>
      </v-card>
    </center>
    <br />
    <div>
      <v-text-field
        dense
        hide-details
        @keyup.enter="goDataTiket()"
        v-model="searchNomorPesanan"
        prepend-inner-icon="mdi-magnify"
        outlined
        label="Cari Nomor Pesanan"
      ></v-text-field>
    </div>
    <br />
    <div style="height:380px">
      <v-row v-if="!isLoading" dense>
        <div
          v-if="listRefundTiket.length == 0"
          style="width:100%;margin-top:100px"
        >
          <center>
            <img width="100px" src="/img/nodatapencairan.png" />
            <h4>Tiket tidak ditemukan</h4>
          </center>
        </div>
        <v-col
          v-else
          v-for="item in listRefundTiket"
          :key="item.id"
          cols="12"
          sm="4"
        >
          <v-card
            @click="
              (refundTiketTemp = item),
                (dialogRefundTiket = true),
                test(refundTiketTemp)
            "
            rounded="xl"
            outlined
            class="pa-3"
          >
            <div class="d-flex justify-space-between">
              <div>
                <h5>{{ item.nama_penjual }}</h5>
                <div style="font-size:14px;color:#989B9E">
                  No. Pesanan {{ item.no_order }}
                </div>
              </div>
              <div style="font-size:14px;color:#989B9E">{{ item.id }}</div>
            </div>
            <div class="mt-2 d-flex align-bottom justify-space-between">
              <div>
                <h5 style="color:#BD251C">{{ item.jumlah }} Tiket</h5>
                <h5 style="font-size:14px;color:#c90000">
                  Rp.
                  {{
                    Number(
                      item.total_pembayaran ? item.total_pembayaran : 0
                    ).toLocaleString('id-ID')
                  }}
                </h5>
              </div>
              <div style="font-size:14px;color:#989B9E" class="mt-5">
                {{ item.created_at | dateTimeFormat }}
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-container style="flex: 1; height: 200px; padding-bottom: 50px" v-else>
        <v-row class="fill-height" align-content="center" justify="center">
          <v-col class="text-subtitle-1 text-center" cols="12">
            Mengambil data, mohon tunggu........
          </v-col>
          <v-col cols="6">
            <v-progress-linear
              color="#c90000"
              indeterminate
              rounded
              height="8"
            ></v-progress-linear>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div class="mt-2">
      <v-pagination
        v-model="page"
        color="#c90000"
        @input="getOrderTiket()"
        :length="lengthPage"
        :total-visible="7"
      ></v-pagination>
    </div>
    <v-dialog v-model="dialogRefundTiket" width="900px" persistent>
      <v-card class="pa-2">
        <div class="d-flex justify-space-between align-center">
          <div style="color: white">X</div>
          <h4 style="color: #c90000">Detail Pengajuan</h4>
          <v-icon @click="(dialogRefundTiket = false), clearBukti()"
            >mdi-close</v-icon
          >
        </div>
        <br />
        <v-row v-if="refundTiketTemp" class="mx-3" dense>
          <v-col cols="12" sm="6">
            <v-card class="pa-3" outlined>
              <div>
                <h4 style="color:#c90000">Informasi Pengajuan</h4>
                <div class="d-flex justify-space-between">
                  <div>Nama</div>
                  <h5>{{ refundTiketTemp.nama_penjual }}</h5>
                </div>
                <div class="d-flex justify-space-between">
                  <div>Nomor Pesanan</div>
                  <div>
                    {{ refundTiketTemp.no_order }}
                    <v-icon small>mdi-content-copy</v-icon>
                  </div>
                </div>
                <div class="d-flex justify-space-between">
                  <div>Tanggal Pengajuan</div>
                  <div>
                    {{ refundTiketTemp.created_at | dateTimeFormat }} WIB
                  </div>
                </div>
                <div class="d-flex justify-space-between">
                  <div>Status</div>
                  <div
                    :style="
                      refundTiketTemp.id_mst_order_status == 1
                        ? 'color: #c90000'
                        : refundTiketTemp.id_mst_order_status == 7
                        ? 'color: #c90000'
                        : refundTiketTemp.id_mst_order_status == 2
                        ? 'color: #E0AA06'
                        : refundTiketTemp.id_mst_order_status == 3
                        ? 'color: #BD251C'
                        : ''
                    "
                  >
                    {{ refundTiketTemp.order_status }}
                  </div>
                </div>
                <div class="d-flex justify-space-between">
                  <div>Total pembayaran</div>
                  <h5 style="color:#af0000">
                    Rp.
                    {{
                      Number(
                        refundTiketTemp.total_pembayaran
                          ? refundTiketTemp.total_pembayaran
                          : 0
                      ).toLocaleString('id-ID')
                    }}
                    <v-icon small>mdi-content-copy</v-icon>
                  </h5>
                </div>
              </div>
            </v-card>
            <v-card outlined class="mt-3 pa-3">
              <div>
                <h4 style="color:#c90000">Tujuan Rekening</h4>
                <div>Transfer Manual</div>
                <v-divider></v-divider>
                <div class="d-flex align-center">
                  <v-avatar>
                    <v-img src="" alt=""></v-img>
                  </v-avatar>
                  <div>
                    <h5>
                      {{
                        refundTiketTemp.app_user_rekening &&
                          refundTiketTemp.app_user_rekening[0].nama_rekening
                      }}
                    </h5>
                    <div style="font-size:14px">
                      {{
                        refundTiketTemp.app_user_rekening &&
                          refundTiketTemp.app_user_rekening[0].bank_name
                      }}
                    </div>
                    <div style="font-size:14px">
                      {{
                        refundTiketTemp.app_user_rekening &&
                          refundTiketTemp.app_user_rekening[0].nomor_rekening
                      }}
                      <v-icon small>mdi-content-copy</v-icon>
                    </div>
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6">
            <v-card outlined class="pa-3">
              <div>
                <h4 style="color:#c90000">Bukti Pembayaran</h4>
                <div v-if="isKonfirmasi">
                  <v-file-input
                    class="d-none"
                    @change="onFileChange"
                    id="inputGambar"
                    v-model="buktiBayar.bukti"
                  ></v-file-input>
                  <div
                    v-if="loadValue == 100 && buktiBayar.bukti"
                    class="py-3"
                    style="border-radius:10px;background:#ffeeee;border:2px dashed #c90000"
                  >
                    <div class="px-3 d-flex justify-center align-center">
                      <v-btn
                        @click="document.getElementById('inputGambar').click()"
                        small
                        block
                        outlined
                        color="#c90000"
                        >Ubah</v-btn
                      >
                    </div>
                  </div>
                  <div
                    v-if="!buktiBayar.bukti"
                    @click="document.getElementById('inputGambar').click()"
                    class="py-4"
                    style="cursor:pointer;border-radius:10px;background:#ffeeee;border:2px dashed #c90000"
                  >
                    <center>
                      <v-icon large color="#c90000"
                        >mdi-cloud-upload-outline</v-icon
                      >
                      <h5 style="font-size:14px;color:#c90000">
                        Unggah bukti pembayaran disini
                      </h5>
                    </center>
                  </div>
                  <div
                    v-else
                    class="py-2 d-flex align-center justify-space-between"
                  >
                    <v-avatar tile>
                      <v-img
                        :src="buktiBayar.gambarBuktiPembayaran"
                        contain
                        :width="50"
                        :height="50"
                      >
                      </v-img>
                    </v-avatar>
                    <div style="width:100%" class="px-2">
                      <div>
                        {{
                          buktiBayar.namaBuktiPembayaran.length > 15
                            ? buktiBayar.namaBuktiPembayaran.substring(0, 15) +
                              '....'
                            : buktiBayar.namaBuktiPembayaran
                        }}
                      </div>
                      <v-progress-linear
                        color="#c90000"
                        :value="loadValue"
                      ></v-progress-linear>
                      <b style="font-size:12px;color:#c90000">
                        <center>{{ loadValue }}%</center>
                      </b>
                    </div>
                    <div>
                      <v-icon
                        @click="clearBukti()"
                        v-if="loadValue < 100"
                        color="red"
                        >mdi-close</v-icon
                      >
                      <v-icon v-else color="#c90000">mdi-check</v-icon>
                    </div>
                  </div>
                  <v-btn
                    @click="dialogTolakRefund = true"
                    class="mt-3"
                    width="100%"
                    outlined
                    color="#BD251C"
                  >
                    tolak refund tiket
                  </v-btn>
                </div>
                <div v-else>
                  <div class="d-flex align-center justify-space-between">
                    <viewer>
                      <img
                        id="buktiBayarRefundTiket"
                        width="50px"
                        height="40px"
                        :src="$url_img + refundTiketTemp.bukti_pembayaran"
                        alt=""
                      />
                    </viewer>
                    <v-btn
                      @click="
                        document.getElementById('buktiBayarRefundTiket').click()
                      "
                      small
                      color="#c90000"
                      class="white--text"
                      >lihat bukti</v-btn
                    >
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-divider class="mt-2"></v-divider>
        <v-btn
          v-if="isKonfirmasi"
          :disabled="
            buktiBayar.buktiCompressed && loadValue == 100 && buktiBayar.bukti
              ? false
              : true
          "
          @click="dialogVerifikasi = true"
          width="100%"
          :style="{
            background: 'linear-gradient(to right, #c90000, #f9c72a)',
            color: 'white'
          }"
          class="mt-3 white--text"
          >Konfirmasi</v-btn
        >
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogTolakRefund" width="400px" persistent>
      <v-card class="pa-3">
        <div class="d-flex justify-space-between align-center">
          <div style="color: white">X</div>
          <h4 style="color: #c90000">Alasan Penolakan</h4>
          <v-icon @click="(dialogTolakRefund = false), (alasanPenolakan = '')"
            >mdi-close</v-icon
          >
        </div>
        <br />
        <v-textarea
          hide-details
          dense
          v-model="alasanPenolakan"
          outlined
          label="Beritahu alasan penolakan"
        ></v-textarea>
        <v-btn
          :disabled="alasanPenolakan == '' ? true : false"
          width="100%"
          @click="dialogVerifikasi = true"
          color="#c90000"
          class="white--text mt-2"
          >Konfirmasi</v-btn
        >
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogVerifikasi" width="400px" persistent>
      <v-card class="pa-3">
        <div class="d-flex justify-space-between align-center">
          <div style="color: white">X</div>
          <h4 style="color: #c90000">
            Verifikasi <span v-if="dialogTolakRefund">penolakan</span> Refund
            Tiket
          </h4>
          <v-icon @click="dialogVerifikasi = false">mdi-close</v-icon>
        </div>
        <br />
        <center>
          <v-avatar size="150" tile>
            <v-img src="/img/nodata.png"></v-img>
          </v-avatar>
          <div>
            Apakah anda yakin untuk konfirmasi
            <span v-if="dialogTolakRefund">penolakan</span> refund tiket ?
          </div>
        </center>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="#c90000"
            class="white--text"
            @click="
              dialogTolakRefund ? postTolakRefund() : postKonfirmasiRefund()
            "
            >ya, konfirmasi</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import 'viewerjs/dist/viewer.css';
import imageCompression from 'browser-image-compression';
import Viewer from 'v-viewer';
import Vue from 'vue';
import moment from 'moment';
Vue.use(Viewer);
export default {
  data() {
    return {
      infoAction: {
        snackbar: false,
        message: '',
        color: ''
      },
      color: { snackbar: '' },
      dialogVerifikasi: false,
      document,
      users: [],
      listRefundTiket: [],
      refundTiketTemp: null,
      isKonfirmasi: true,
      dialogTolakRefund: false,
      alasanPenolakan: '',
      limit: 9,
      offset: 0,
      page: 1,
      lengthPage: 0,
      searchNomorPesanan: '',
      dialogRefundTiket: false,
      buktiBayar: {
        bukti: null,
        gambarBuktiPembayaran: null,
        namaBuktiPembayaran: '',
        buktiCompressed: null
      },
      loadValue: 0,
      isLoading: false
    };
  },
  filters: {
    countDoc(doc) {
      if (doc !== null) {
        return true;
      }
    },
    datediff: date => {
      return moment(date).from();
    },
    dateFormat: date => {
      return moment.utc(date).format('DD MMM YYYY');
    },
    timeFormat: date => {
      return moment.utc(date).format('HH:mm');
    },
    dateTimeFormat: date => {
      return moment.utc(date).format('DD MMM YYYY HH:mm');
    }
  },
  methods: {
    test(data) {
      console.log(data);
    },
    clearBukti() {
      this.buktiBayar = {
        bukti: null,
        gambarBuktiPembayaran: null,
        namaBuktiPembayaran: '',
        buktiCompressed: null
      };
      this.loadValue = 0;
    },
    goDataTiket() {
      this.limit = 9;
      this.offset = 0;
      this.page = 1;
      this.lengthPage = 0;
      this.getOrderTiket();
    },
    onFileChange() {
      this.buktiBayar.gambarBuktiPembayaran = URL.createObjectURL(
        this.buktiBayar.bukti
      );
      this.buktiBayar.namaBuktiPembayaran = this.buktiBayar.bukti.name;

      // console.log('gambarBuktiPembayaran', this.gambarBuktiPembayaran)
      // console.log('namaBuktiPembayaran', this.namaBuktiPembayaran)
      // this.compressImage()
      this.handleImageUpload();
      this.startProgressUpload();
    },
    startProgressUpload() {
      this.loadValue = 0;
      this.progressLoad = setInterval(() => {
        if (this.loadValue < 100) {
          this.loadValue = this.loadValue + 5;
        } else {
          clearInterval(this.progressLoad);
        }
      }, 100);
    },
    async handleImageUpload() {
      const imageFile = this.buktiBayar.bukti;
      // console.log('originalFile instanceof Blob', imageFile instanceof Blob); // true
      // console.log(`originalFile size ${imageFile.size / 1024 / 1024} MB`);

      const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1024,
        useWebWorker: true
      };
      try {
        const compressedFile = await imageCompression(imageFile, options);
        // this.buktiBayarCompress = compressedFile
        this.buktiBayar.buktiCompressed = this.blobToFile(
          compressedFile,
          this.buktiBayar.namaBuktiPembayaran
        );
        console.log('bukti bayuar', this.buktiBayar);
        // console.log('compressedFile instanceof Blob', compressedFile instanceof Blob); // true
        // console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB
        // console.log('hasil comp', compressedFile)
        // await uploadToServer(compressedFile); // write your own logic
      } catch (error) {
        console.log(error);
      }
    },
    blobToFile(theBlob, fileName) {
      return new File([theBlob], fileName, {
        lastModified: new Date().getTime(),
        type: theBlob.type
      });
    },
    async getOrderTiket() {
      this.isLoading = true;
      let params = new URLSearchParams();

      params.set('id_mst_order_jenis_iklan', 1);
      params.set('id_mst_order_type', 2);
      if (this.searchNomorPesanan != '') {
        params.set('no_order', this.searchNomorPesanan);
      }
      if (this.isKonfirmasi) {
        params.set('id_mst_pembayaran_status', 1);
      } else {
        params.set('id_mst_pembayaran_status', 2);
      }
      var offset = (this.offset = (this.page - 1) * this.limit);
      params.append('offset', offset);
      params.append('limit', this.limit);

      var request = {
        params: params,
        headers: { Authorization: 'Bearer ' + this.users.token }
      };
      await this.$req
        .get(this.$root.$baseapi.transaksi + '/transaksi/v4/order', request)
        .then(response => {
          let { data } = response.data;
          this.listRefundTiket = data == null ? [] : data;
          var mod = response.data.count % this.limit;
          var lengthPage = 0;

          lengthPage = (response.data.count - mod) / this.limit;

          if (mod == 0) {
            this.lengthPage = lengthPage;
          } else {
            this.lengthPage = lengthPage + 1;
          }
          console.log('list refund tiket', this.listRefundTiket);
          this.isLoading = false;
        })
        .catch(error => {
          let responses = error.response.data;
          console.log(responses.api_message);
        });
    },
    async postKonfirmasiRefund() {
      let formData = new FormData();

      formData.set('id', this.refundTiketTemp.id);
      formData.set('id_biz_user', this.users.id);
      formData.set('foto', this.buktiBayar.buktiCompressed);
      formData.set('created_by_type', 2);
      formData.set('created_by', this.users.id);
      formData.set('id_pembayaran', this.refundTiketTemp.id_pembayaran);

      await this.$req
        .post(
          this.$root.$baseapi.transaksi +
            '/transaksi/v3/konfirmasi_pencairan_tiket',
          formData,
          {
            headers: { Authorization: 'Bearer ' + this.users.token }
          }
        )
        .then(response => {
          this.clearBukti();
          this.getOrderTiket();
          this.dialogRefundTiket = false;
          this.dialogVerifikasi = false;
          this.infoAction = {
            snackbar: true,
            message: response.data.api_message,
            color: 'success'
          };
        })
        .catch(error => {
          let responses = error.response.data;
          this.infoAction = {
            snackbar: true,
            message: responses.api_message,
            color: 'error'
          };
        });
    },
    async postTolakRefund() {
      let formData = new FormData();

      formData.set('id', this.refundTiketTemp.id);
      formData.set('id_mst_pembayaran_note', 1);
      formData.set('note_detail', this.alasanPenolakan);

      await this.$req
        .post(
          this.$root.$baseapi.transaksi + '/transaksi/v3/tolak_pencairan_tiket',
          formData,
          {
            headers: { Authorization: 'Bearer ' + this.users.token }
          }
        )
        .then(response => {
          // this.color.snackbar = 'success';
          // this.message = response.data.api_message;
          // this.snackbar = true;
          this.clearBukti();
          this.getOrderTiket();
          this.dialogRefundTiket = false;
          this.dialogVerifikasi = false;
          this.dialogTolakRefund = false;
          this.infoAction = {
            snackbar: true,
            message: response.data.api_message,
            color: 'success'
          };
        })
        .catch(error => {
          let responses = error.response.data;
          this.infoAction = {
            snackbar: true,
            message: responses.api_message,
            color: 'error'
          };
        });
    }
  },
  created() {
    let users = localStorage.getItem('user');
    this.users = JSON.parse(users);
    console.log('userrrrefund', this.users);
    this.getOrderTiket();
  }
};
</script>
